export const UTM_CAMPAIGN_DYNAMIC_LINKS = 'dynamicLinks';
